<template>
    <a :class="linkCssClass" @click.prevent="clicked">
        <slot></slot>
    </a>
</template>
<script>
    export default {
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            route: {
                type: String,
                required: true
            },
            message: {
                type: String,
                required: true
            },
            cssClass: {
                type: String,
                required: false
            },
            enabled: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        computed: {
            linkCssClass() {
                let css = [];

                if (this.cssClass) {
                    css.push(this.cssClass);
                }

                if (!this.enabled) {
                    css.push('disabled');
                }

                return css.join(' ');
            }
        },
        methods: {
            clicked() {
                if (!this.enabled) {
                    return;
                }

                EventBus.fire('top-confirm', {
                    id: 'confirm-dialog-' + this.id,
                    message: this.message,
                    url: this.route
                });
            },
            confirm(message) {
                EventBus.fire('top-alert', {
                    id: 'alert-dialog-' + this.id,
                    message: message
                });
            }
        }
    };
</script>